import { datadogRum } from '@datadog/browser-rum';

const currentConfig = {
  BASE_URL: window.REACT_APP_BASE_URL || import.meta.env.REACT_APP_BASE_URL,
  RECAPTCHA_KEY:
    window.RECAPTCHA_KEY || import.meta.env.RECAPTCHA_KEY || '6Ld1TLEaAAAAAAlr20gdHD5tnrWcTX8MT7abwglB',
  REACT_APP_DOMAIN_PREFIX: window.REACT_APP_DOMAIN_PREFIX || import.meta.env.REACT_APP_DOMAIN_PREFIX,
};

const ENV = window.REACT_APP_ENV || import.meta.env.REACT_APP_ENV;
const DD_APP_ID = window.REACT_APP_DD_APPLICATION_ID || import.meta.env.REACT_APP_DD_APPLICATION_ID;

export const initDataDog = () => {
  const applicationId = DD_APP_ID;
  if (applicationId) {
    datadogRum.init({
      applicationId: DD_APP_ID,
      clientToken: window.REACT_APP_DD_CLIENT_TOKEN || import.meta.env.REACT_APP_DD_CLIENT_TOKEN,
      site: 'datadoghq.com',
      service: `${ENV}/${window.REACT_APP_SIDE || import.meta.env.REACT_APP_SIDE}`,
      env: ENV,
      version: window.REACT_APP_VERSION || import.meta.env.REACT_APP_VERSION,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 100,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: 'mask-user-input',
      enableExperimentalFeatures: ['feature_flags'],
      allowedTracingUrls: [
        window.REACT_APP_BASE_URL || import.meta.env.REACT_APP_BASE_URL,
        window.REACT_APP_AMPLIFY_PUBLIC_BASE_URL || import.meta.env.REACT_APP_AMPLIFY_PUBLIC_BASE_URL,
      ],
    });
  }
};

export interface DataDogUser {
  id: string;
  person_id?: string;
  employee_id?: string;
  [key: string]: string | undefined;
}

/**
 * Attach the signed-in user to every RUM event that follows.
 * Safe to call before init or when RUM is disabled (no app id, tests).
 */
export const setDataDogUser = (user: DataDogUser) => {
  if (!user.id) return;
  try {
    datadogRum.setUser(user);
  } catch {
    /* RUM not available */
  }
};

/**
 * Close the current RUM session on logout / token expiry.
 *
 * DataDog stamps a session's `usr.*` from its most recent event. Without this,
 * the reload to /login after logout keeps the same session alive with anonymous
 * events, and the whole session ends up unattributed (EL-30448).
 * A new session starts with the next user interaction.
 */
export const stopDataDogSession = () => {
  try {
    datadogRum.stopSession();
  } catch {
    /* RUM not available */
  }
};

export default currentConfig;
